import * as marked from 'marked';
import { useEffect, useRef } from 'react';
import { trpc } from '../../utils/trpc/trpc.ts';


export function ReleaseNotes() {
    const releaseNotesRef = useRef<HTMLDivElement>(null);

    const releaseNotesFetch = trpc.serverState.getReleaseNotes.useQuery();

    useEffect(() => {
        if (releaseNotesFetch.data) {
            const html = marked.parse(releaseNotesFetch.data) as string;
            releaseNotesRef.current!.innerHTML = html;
        }
    }, [releaseNotesFetch.data]);


    return (
        <div className='div__release-notes'>
            <h1>Release notes</h1>
            <div ref={releaseNotesRef}>Loading...</div>
            <img src='/cofundedbytheEU_logo.png' width='500' />
        </div>
    );
}